/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-08-01 15:41:11
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-08-01 15:49:36
 * @FilePath: /designcenter/src/store/productSelection.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from 'pinia'

interface ProductSelectionState {
  selectedProductIds: number[]
}

export const useProductSelectionStore = defineStore('productSelection', {
  state: (): ProductSelectionState => ({
    selectedProductIds: [],
  }),

  actions: {
    setSelectedProductIds(ids: number[]) {
      this.selectedProductIds = ids
    },

    addProductId(id: number) {
      if (!this.selectedProductIds.includes(id)) {
        this.selectedProductIds.push(id)
      }
    },

    removeProductId(id: number) {
      const index = this.selectedProductIds.indexOf(id)
      if (index > -1) {
        this.selectedProductIds.splice(index, 1)
      }
    },

    clearSelectedProductIds() {
      this.selectedProductIds = []
    },
  },
})
